import React, { Component } from 'react'
import {BrowserQRCodeReader} from "@zxing/library";
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
});

export class QRScanner extends Component {
    constructor(props){
        super(props);
        this.state = {
            display : "none"
        }
    }

    componentDidMount = async () => {
        await this.handleScan()
    }
    componentWillUnmount = async() => {
        await this.stop()
    }
    handleScan = async () => {
        let result = "";
        try {
            this.setState({
                display: "block"
            })
            
            const codeReader = new BrowserQRCodeReader();
            const previewElem = document.querySelector(
              "#test-area-qr-code-webcam > video"
            );
            const controls1 = await codeReader.decodeOnceFromVideoDevice(
              undefined,
              previewElem
            );
            result = controls1.text;
            if (result) {
              await this.props.handleScanWebCam(result)
                // result = decodeURIComponent(result);
                // if(result.includes('client') || result.includes('claimNumber') || result.includes('customerCompany') || result.includes('OrderNo') || result.includes('RegNo') || result.includes('Color') || result.includes('PartnerName') || result.includes('Model') || result.includes("ActualVin") || result.includes("Make")){
                //     result = result.split('&')
                //     result = result.map((r) => r.split('='))
                //     this.props.handleScanWebCam(result,controls1.text);
                //     this.setState({
                //         display: "none"
                //     })
                //     codeReader.reset()
                // } else {
                //   Toast.fire({
                //     type: 'error',
                //     title: 'Your QR is malformed. Please try again later.'
                //   }).then(() => {
                //     this.props.handleScanWebCam();
                //   })
                //   codeReader.reset()
                // }
              }
          } catch (error) {
          }
          
    }
    stop = (e) => {
        var stream = document.getElementById('video').srcObject;
        if(stream) {
          var tracks = stream.getTracks();
          for (var i = 0; i < tracks.length; i++) {
            var track = tracks[i];
            track.stop();
          }
        }
        document.getElementById('video').srcObject = null;
        
      }
  render() {
    const {display} = this.state
    return (
        <div id='test-area-qr-code-webcam' className={`d-${display} ${display}`}>
            <video 
                id="video"
                width="100%"
                style={{ border: "1px solid gray", borderRadius:"10px", minHeight:"400" , display: display }}>    
            </video>
        </div>
    )
  }
}

export default QRScanner